import handleError from "../../../utils/handleError";
import { GetHistoryByFiltersRequestBuilder } from "client-sdk/src/entrances/getHistory";
import Client from "client-sdk/src/client";

const token = localStorage.getItem("token");

export async function getHistoryByFilters(filterparams: object) {
  try {
    const filterEntranceHistory = new GetHistoryByFiltersRequestBuilder()
      .params(filterparams)
      .build();
    const client = new Client(token as string);
    const response = client.execute(
      filterEntranceHistory,
    );
    return response;
  } catch (error) {
    return handleError(error.response);
  }
}
export default getHistoryByFilters;
